import emailjs from '@emailjs/browser'

export const EJS_SERVICE   = 'a2g'
export const EJS_PUBLIC_KEY = 's1Ci-dBYzktafO8u7'

export const TEMPLATES = {
  inquiry:   'template_kzn34x1',
  subscribe: 'template_p6khcrf',
}

export const COMPANY = {
  name:  'A2G',
  email: 'key.eu@datium.xyz',
  url:   'https://a2g.co.kr',
}

export function sendEmail(templateId, params) {
  return emailjs.send(EJS_SERVICE, templateId, params, EJS_PUBLIC_KEY)
}
